exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/common/maintenance-mode/maintenance-mode.component.css
// module id = ../../../../../src/app/common/maintenance-mode/maintenance-mode.component.css
// module chunks = 0